import { ApiReturn } from '@utils/ApiReturn'
import { StoreAtom } from 'ketshopweb-sdk'
import { KetshopwebServices } from 'ketshopweb-services'
import { cloneDeep } from 'lodash'

// define the type of the menu
type MenuItem = ApiReturn<KetshopwebServices.FrontendService['GetMenuSetting']>['menu'][0]
type MainMenuSetting = ApiReturn<KetshopwebServices.FrontendService['GetMenuSetting']>['setting'][string]
type SubMenuSetting = ApiReturn<KetshopwebServices.FrontendService['GetMenuSetting']>['sub_menu'][string]

// Initial state
export const MenuSettingStateDefault: MainMenuSetting = {
  type: 'list',
  display_type: 'square',
  wrapper_type: 'square',
  display_arrow: true,
  full_display: false,
  gap_left_right: 0,
  colum_v2: false,
  layout3: {
    column: 4,
    perpage: 4,
  },
}
export const SubMenuSettingStateDefault: SubMenuSetting = {
  column: 1,
  display_type: 'column',
  banner: {
    image: '',
    image_size: 'ratio_4by6',
    crop_image: true,
    link: '',
    custom_link: false,
  },
}

function MergeMainMenuSetting(current: MainMenuSetting) {
  const default_setting = cloneDeep(MenuSettingStateDefault)
  return {
    ...default_setting,
    ...current,
    layout3: {
      ...default_setting.layout3,
      ...current.layout3,
    },
  }
}

function MergeSubMenuSetting(current: SubMenuSetting) {
  const default_setting = cloneDeep(SubMenuSettingStateDefault)
  return {
    ...default_setting,
    ...current,
    banner: {
      ...default_setting.banner,
      ...current.banner,
    },
  }
}
// stores
export const MenuSettingStore = StoreAtom<{
  running: {
    menu: MenuItem[]
    setting: {
      // key is page_id
      [key: string]: MainMenuSetting
    }
    sub_menu: {
      // key is page_id
      [key: string]: SubMenuSetting
    }
  }
  changing: {
    menu: MenuItem[]
    setting: {
      // key is page_id
      [key: string]: MainMenuSetting
    }
    sub_menu: {
      // key is page_id
      [key: string]: SubMenuSetting
    }
  }
}>({
  running: {
    menu: [],
    setting: {},
    sub_menu: {},
  },
  changing: {
    menu: [],
    setting: {},
    sub_menu: {},
  },
})

export const MenuListStore = StoreAtom<MenuItem[]>([])
export const MenuSettingSelectorLevel1 = StoreAtom<MenuItem | undefined>(undefined)
export const MenuSettingSelectorLevel2 = StoreAtom<MenuItem | undefined>(undefined)
export const MenuSettingSelectorLevel3 = StoreAtom<MenuItem | undefined>(undefined)
export const MenuSettingSelectorLevel3Colum1 = StoreAtom<MenuItem[]>([])
export const MenuSettingSelectorLevel3Colum2 = StoreAtom<MenuItem[]>([])
const LastActiveMenuLevel1 = StoreAtom<MenuItem | undefined>(undefined)
export const SubMenuColumnBanner = StoreAtom<{
  // column: numberx
  [key: string]: MenuItem[]
}>({})

export function PrepareSubMenuColumnBanner() {
  const data = MenuSettingStore.get()
  console.log('[PrepareSubMenuColumnBanner][MenuSettingStore]', data)
  const current = MenuSettingSelectorLevel1.get()
  if (current && data.changing.setting[current.page_id]) {
    const setting = data.changing.setting[current.page_id]
    if (setting.type == 'column_banner') {
      SubMenuColumnBanner.set({})
      let layout3 = cloneDeep(MenuSettingStateDefault.layout3)
      if (setting.layout3) {
        layout3 = setting.layout3
      }
      console.log('layout3', layout3)
      const layout = {}
      for (const item of current.childrens) {
        if (Object.keys(layout).length === layout3.perpage) {
          break
        }
        const sub_setting = MenuSettingStore.get().changing.sub_menu[item.page_id]
        if (sub_setting && sub_setting.column) {
          const column = sub_setting.column
          if (layout[column]) {
            continue
          }
          layout[column] = true
          SubMenuColumnBanner.set({
            ...SubMenuColumnBanner.get(),
            [column]: [item],
          })
        }
      }
      if (Object.keys(layout).length !== layout3.perpage) {
        const smcb = SubMenuColumnBanner.get()
        let temp = [] as MenuItem[]
        Object.values(smcb).forEach((item) => {
          temp = [...temp, ...item]
        })
        current.childrens.forEach((item, index) => {
          let column = index + 1
          if (!temp.find((x) => x.page_id == item.page_id) && Object.keys(layout).length !== layout3.perpage) {
            if (column > layout3.perpage) {
              column = 1
            }
            if (!layout[column]) {
              layout[column] = true
              SubMenuColumnBanner.set({
                ...SubMenuColumnBanner.get(),
                [column]: [item],
              })
              let sub_setting = MenuSettingStore.get().changing.sub_menu[item.page_id]
              if (!sub_setting || !sub_setting.column) {
                GetMenuSetting('sub', item.page_id)
              }
              sub_setting = MenuSettingStore.get().changing.sub_menu[item.page_id]
              if (sub_setting.column !== column) {
                sub_setting.column = column
              }
            }
          }
        })
      }
    }
  }
  console.log('SubMenuColumnBanner', SubMenuColumnBanner.get())
}
MenuSettingStore.subscribe(() => {
  PrepareSubMenuColumnBanner()
})
MenuSettingSelectorLevel1.subscribe((res) => {
  if (!res) return
  LastActiveMenuLevel1.set(res)
  PrepareSubMenuColumnBanner()
})
MenuSettingSelectorLevel2.subscribe((data) => {
  // console.log('MenuSettingSelectorLevel2', data)
  if (data) {
    MenuSettingSelectorLevel3.set(undefined)
    MenuSettingSelectorLevel3Colum1.set([])
    MenuSettingSelectorLevel3Colum2.set([])

    if (data.childrens) {
      for (const item of data.childrens) {
        if (!MenuSettingStore.get().changing.sub_menu[item.page_id]) {
          GetMenuSetting('sub', item.page_id)
        }
      }
    } else {
      data.childrens = []
    }

    // const sub_menus = Object.keys(MenuSettingStore.get().changing.sub_menu)
    for (const menu of data.childrens) {
      const page_id = Number(menu.page_id)
      let sub_setting = MenuSettingStore.get().changing.sub_menu[page_id]
      if (!sub_setting) {
        //
        try {
          const parse = JSON.parse(menu.setting) as {
            sub_menu: SubMenuSetting
          }
          sub_setting = parse.sub_menu
        } catch {}
      }
      if (Object.keys(sub_setting || {}).length === 0) {
        GetMenuSetting('sub', page_id)
        sub_setting = MenuSettingStore.get().changing.sub_menu[page_id]
      }
      console.log('sub_setting', sub_setting, menu)
      if (sub_setting.column === 1) {
        MenuSettingSelectorLevel3Colum1.set([...(MenuSettingSelectorLevel3Colum1.get() || []), menu])
      } else if (sub_setting.column === 2) {
        MenuSettingSelectorLevel3Colum2.set([...(MenuSettingSelectorLevel3Colum2.get() || []), menu])
      }
    }
  }
})
MenuSettingSelectorLevel3Colum1.subscribe((data) => {
  console.log('MenuSettingSelectorLevel3Colum1 [Change]')
  for (const item of data) {
    GetMenuSetting('sub', item.page_id)
    MenuSettingStore.get().changing.sub_menu[item.page_id].column = 1
  }
})
MenuSettingSelectorLevel3Colum2.subscribe((data) => {
  console.log('MenuSettingSelectorLevel3Colum2 [Change]')
  for (const item of data) {
    GetMenuSetting('sub', item.page_id)
    MenuSettingStore.get().changing.sub_menu[item.page_id].column = 2
  }
})

// Initial state
export const MenuSettingInitStore = async (svc: KetshopwebServices.FrontendService) => {
  const last_active = LastActiveMenuLevel1.get()
  SubMenuColumnBanner.set({})
  MenuSettingSelectorLevel3Colum2.set([])
  MenuSettingSelectorLevel3Colum1.set([])
  MenuSettingSelectorLevel3.set(undefined)
  MenuSettingSelectorLevel2.set(undefined)
  MenuSettingSelectorLevel1.set(undefined)
  MenuSettingStore.set({
    running: {
      menu: [],
      setting: {},
      sub_menu: {},
    },
    changing: {
      menu: [],
      setting: {},
      sub_menu: {},
    },
  })
  const menu = await svc.GetMenuSetting().catch((e) => {
    console.error('MenuSettingModel', e)
    return {
      menu: [],
      setting: {},
      sub_menu: {},
    } as ApiReturn<KetshopwebServices.FrontendService['GetMenuSetting']>
  })
  MenuSettingStore.set({
    running: menu,
    changing: cloneDeep(menu),
  })
  const changing = MenuSettingStore.get().changing
  GetMenuSetting('main', changing.menu[0].page_id)
  for (const sub of changing.menu[0].childrens) {
    GetMenuSetting('sub', sub.page_id)
  }
  // MenuSettingSelectorLevel1.set(changing.menu[0])
  if (last_active) {
    const menu = changing.menu.find((item) => item.page_id == last_active.page_id)
    if (menu) {
      MenuSettingSelectorLevel1.set(menu)
    } else {
      MenuSettingSelectorLevel1.set(changing.menu[0])
    }
  } else {
    MenuSettingSelectorLevel1.set(changing.menu[0])
  }
}
export const GetMenuSetting = (type: 'main' | 'sub', page_id: number) => {
  const state = MenuSettingStore.get()
  if (type == 'main') {
    if (!Object.keys(state.changing.setting[page_id] || {}).length) {
      state.changing.setting[page_id] = cloneDeep(MenuSettingStateDefault)
    } else {
      // merge the setting
      state.changing.setting[page_id] = MergeMainMenuSetting(state.changing.setting[page_id])
    }
    return state.changing.setting[page_id]
  } else if (type == 'sub') {
    if (!Object.keys(state.changing.sub_menu[page_id] || {}).length) {
      state.changing.sub_menu[page_id] = cloneDeep(SubMenuSettingStateDefault)
    } else {
      // merge the setting
      state.changing.sub_menu[page_id] = MergeSubMenuSetting(state.changing.sub_menu[page_id])
    }
    return state.changing.sub_menu[page_id]
  }
}
